<template>
  <div v-if="templates?.length" class="mt-3">
    <SelectGroup v-model="object.official_whatsapp_template_id"
                 :options="templates"
                 :label="$t('official_whatsapp_template')"
                 :showlabel="true"
                 :translate="false"
                 :null-option="true"
                 :show-errors="true"
                 validation-id="official_whatsapp_template_id"
                 variant="white"/>
    <div class="small text-muted">{{ $t(copyText ? 'owa_template_select_hint' : 'owa_birthday_template_select_hint') }}</div>
    <div v-if="selected?.header" class="small text-muted mt-1">{{ $t('owa_template_with_header_hint', { header: $t(`owa_header_${selected.header}`) }) }}</div>
  </div>
</template>

<script setup>
import { computed, watch } from "vue"
import SelectGroup from "@/components/form/SelectGroup.vue"

// approved official whatsapp templates come only when the number is connected through Aiva.
// When official mode is on, whatsapp messages are sent only by the selected template, its text goes to the other channels too
const props = defineProps({
  object: {
    type: Object
  },
  templates: {
    type: Array,
    default: () => []
  },
  // notification settings and mailings send the template text to the other channels; birthday greetings keep their own sms text
  copyText: {
    type: Boolean,
    default: true
  },
})

// template with a media header takes the attachment of the notification / the image of the mailing, without it the message is not sent
const selected = computed(() => (props.templates || []).find(t => Number(t.id) === Number(props.object.official_whatsapp_template_id)))

// the list depends on the form (notification type, channel): a template that is not in it anymore is not saved
watch(() => props.templates, (templates) => {
  const id = props.object.official_whatsapp_template_id
  if(id && !(templates || []).some(t => Number(t.id) === Number(id))) props.object.official_whatsapp_template_id = null
}) // not immediate: the list may still be loading when the form opens

watch(() => props.object.official_whatsapp_template_id, (id) => {
  if(!props.copyText) return
  const template = (props.templates || []).find(t => Number(t.id) === Number(id))
  if(template) props.object.text = template.text
})
</script>
